export default [
  {
    path: 'find-org-by-direction',
    name: 'find-org-by-direction',
    component: () => import('@/views/pages/front/find-org-by-direction/FindOrgByDirection.vue'),
    meta: {
      pageTitle: 'Find organization by direction',
      breadcrumb: [
        {
          text: 'Find organization by direction',
          active: true,
        },
      ],
    },
  },
]
